import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {Card, Input, Form, Dropdown, Grid} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {setErrorMessage} from '../../../../common/components/form/common';
import {getProviders, getDealers, getTransportsOptions} from './utils';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';
import {INVOICE} from '../../../../common/forms';
import DatePickerField from '../../../../common/components/form/datePicker';
import InvoiceFormButtons from './buttons';
import InvoiceTable from './table';

class InvoiceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'typeOfSubmit': null,
      'refreshPage': false,
      'errors': [],
    };
    this.renderDatePicker = this.renderDatePicker.bind(this);
    this.changeTypeOfSubmit = this.changeTypeOfSubmit.bind(this);
    this.handleErrorState = this.handleErrorState.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.InvoiceLoad, scopes.Create)) {
      this.props.push(paths.AccessDenied);
    }

    const {invoice, providerId} = this.props;
    this.props.loadProviders({'fields': 'code,name'});
    this.props.fetchSystemParameter('WEIGHT_CHK');
    this.props.fetchDealers('importers');

    if (invoice && providerId) {
      this.props.fetchInvoiceData(invoice, providerId);
      return;
    }
    this.props.loadInitialData();
  }

  checkInitialData(prevInvoice, prevProviderId) {
    const {invoice, providerId} = this.props;
    if (invoice === prevInvoice && providerId === prevProviderId) {
      return;
    }
    this.setState({'refreshPage': false});
    if (invoice && providerId) {
      this.props.fetchInvoiceData(invoice, providerId);
      return;
    }
    this.props.loadInitialData();
  }

  checkRedirectPage(prevInvoice, prevProviderId, formData) {
    const {invoice, providerId} = this.props;
    if (!prevInvoice && !prevProviderId) {
      this.props.push(
        `/carga/factura/${formData.invoice}/proveedor/${formData.providerId}`
      );
      return;
    }
    if (invoice === prevInvoice && providerId === prevProviderId) {
      return;
    }
    this.props.fetchInvoiceData(invoice, providerId);
  }

  checkRequiredField(value) {
    return value ? null : 'Required';
  }

  componentDidUpdate(prevProps) {
    const {invoice, providerId, invoiceSavedOrCancelled, action,
      formInvoiceNumber, formProviderId} = this.props;
    const {refreshPage} = this.state;
    this.checkInitialData(prevProps.invoice, prevProps.providerId);

    if (!prevProps.invoiceSavedOrCancelled && invoiceSavedOrCancelled && !refreshPage && action === 'save') {
      this.setState({'refreshPage': true});
      const formData = {'invoice': formInvoiceNumber, 'providerId': formProviderId};
      this.checkRedirectPage(prevProps.invoice, prevProps.providerId, formData);
    }
    if (
      !prevProps.invoiceSavedOrCancelled &&
      invoiceSavedOrCancelled &&
      !refreshPage &&
      (action === 'send' || action === 'cancel')
    ) {
      this.setState({'refreshPage': true});
      this.props.push(paths.InvoiceLoad);

      if (
        invoice === prevProps.invoice &&
        providerId === prevProps.providerId &&
        refreshPage
      ) {
        this.setState({'refreshPage': false});
        this.props.loadInitialData();
      }
    }
  }

  changeTypeOfSubmit(type) {
    this.setState({'typeOfSubmit': type});
  }

  handleErrorState(errors) {
    this.setState({'errors': errors});
  }
    
  renderDropdown = (field) => {
    return (
      <Dropdown
        selection
        options={field.options}
        value={field.input.value}
        search
        onChange={(e, {value}) => field.input.onChange(value)}
        placeholder='Seleccione una opción'
        className={!field.input.value && field.required ? 'required-value' : null}
        disabled={field.disabled}
      />
    );
  };

  renderDatePicker({disabled, input}) {
    return <DatePickerField input={input} disabled={disabled} />;
  }

  render() {
    const {errors, typeOfSubmit} = this.state;
    const {handleSubmit, submitting, dealersList, providers,
      invalid, invoice, invoiceStatus, reset, providerId, onSubmit} = this.props;
    const editingAllowedOfInvoice = !invoice || (invoice && invoiceStatus === 'I');

    return (
      <Form
        className='invoice-form'
        onSubmit={handleSubmit(onSubmit.bind(this, typeOfSubmit))}
        loading={submitting}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>
                {invoice ? 'Edición' : 'Ingreso'} de Facturas de Importación
              </h2>
              <InvoiceFormButtons
                invoice={invoice}
                invoiceStatus={invoiceStatus}
                invalid={invalid}
                submitting={submitting}
                reset={reset}
                providerId={providerId}
                handleErrorState={this.handleErrorState}
                changeTypeOfSubmit={this.changeTypeOfSubmit}
              />
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Número Factura</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      name='invoiceNumber'
                      component={Input}
                      required
                      maxLength={30}
                      onInvalid={(event) =>
                        setErrorMessage('Por favor, llene este campo', event)
                      }
                      onInput={(event) => setErrorMessage('', event)}
                      normalize={(value) => value.toUpperCase()}
                      disabled={!editingAllowedOfInvoice}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Proveedor</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      name='providerId'
                      component={this.renderDropdown}
                      options={getProviders(providers)}
                      required
                      validate={this.checkRequiredField}
                      disabled={!editingAllowedOfInvoice}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Fecha Factura</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      name='invoiceDate'
                      component={this.renderDatePicker}
                      disabled={!editingAllowedOfInvoice}
                      validate={this.checkRequiredField}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Importador</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      name='dealerId'
                      component={this.renderDropdown}
                      options={getDealers(dealersList)}
                      required
                      validate={this.checkRequiredField}
                      disabled={!editingAllowedOfInvoice}
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Fecha Embarque</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      name='boardingDate'
                      component={this.renderDatePicker}
                      validate={this.checkRequiredField}
                      disabled={!editingAllowedOfInvoice}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Transporte</h4>
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      name='transportation'
                      component={this.renderDropdown}
                      options={getTransportsOptions()}
                      required
                      validate={this.checkRequiredField}
                      disabled={!editingAllowedOfInvoice}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <InvoiceTable
          errors={errors}
          invoice={invoice}
          invoiceStatus={invoiceStatus}
        />
      </Form>
    );
  }
}

export {InvoiceForm};

const form = reduxForm({
  'form': INVOICE.name,
})(InvoiceForm);

const mapStateToProps = (state) => {
  const formValues = formValueSelector(INVOICE.name);
  const formInvoiceNumber = formValues(state, 'invoiceNumber');
  const formProviderId = formValues(state, 'providerId');
  const invoiceStatus = formValues(state, 'invoiceStatus');

  return {
    formInvoiceNumber,
    formProviderId,
    invoiceStatus,
    'saving': state.form.invoice.saving,
    'cancelling': state.form.invoice.cancelling,
    'action': state.form.invoice.action,
    'invoiceSavedOrCancelled': state.form.invoice.invoiceSavedOrCancelled,
    'providers': state.provider.list,
    'dealersList': state.dealer.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  loadInitialData,
  loadProviders,
  fetchDealers,
  fetchInvoiceData,
  fetchSystemParameter,
} = Actions;

export default connect(mapStateToProps, {
  loadInitialData,
  loadProviders,
  fetchDealers,
  fetchInvoiceData,
  fetchSystemParameter,
})(form);
